export default __webpack_public_path__ + "static/media/logo-desktop.a887a3cc.svg";